import React, { Component } from 'react';
import {createSelector} from "reselect";
import {connect} from "react-redux";
import { Main } from '../../layout';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import Skeleton from '@material-ui/lab/Skeleton';
import Rating from '@material-ui/lab/Rating';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import { IconButton } from '@material-ui/core';
import { Pagination } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';
import { LoginDialog } from '../Common';
import { Role } from '../../../helpers';

class TutorSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formField: {
                name: '',
                subject: '',
                location: '',
                page: 1,
                'per-page': 20
            },
            open: false,
            items: [],
            pagination: null,
            loading: false,
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    componentDidMount() {
        const { history } = this.props;
        const { state } = history.location;
        let url = new URL(window.location.href);
        let get_subject = url.searchParams.get("subject");
        let formField = {...this.state.formField};

        formField['subject'] = state && state.formField && state.formField.subject;
        if (typeof formField['subject'] === 'undefined') {
            formField['subject'] = get_subject;
        }
        formField['location'] = state && state.formField && state.formField.location;
        this.setState({formField}, () => this.loadTutor(formField));    
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};            
        if(name === 'subject') {
            const { categories } = this.props;
            if(value){
                const cateArray = categories && categories.data ? categories.data.filter(el => el.name === value) : [];
                const cate = cateArray && cateArray[0];
                formField['subject'] = cate.name;
            } else {
                formField['subject'] = '';
            }
        } else {
            formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        }
        this.setState({formField});
    };

    loadTutor = (formField = null) => {
        const { dispatch } = this.props;
        this.setState({loading: true});
        itemService.search("GET", null, formField).then(data => {
            if(data.success) {
                let items = data.items;
                let pagination = data.pagination;
                this.setState({loading: false, items, pagination});
            }
        })
        .catch(exception => {
            gs.showErrors(exception, dispatch, alertSelectors);
            this.setState({loading: false});
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField } = this.state;        
        if(this.validator.allValid()) {
            this.loadTutor(formField);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    markAsFavorite = (item) => {
        if(!gs.identity) {
            this.setState({open: true});
            return false;
        }
        const { dispatch, authentication } = this.props;
        const { user } = authentication.authentication;
        const params = {
            "userFavorite": {
                user_id: user.user_id,
                favorite_id: item.user_id,
                moduleId: "UserProfile"
            }
        };

        let method = (item.is_favorite) ? "DELETE" : "POST";
        let param = (item.is_favorite) ? { item_id: item.is_favorite } : null;
        let action = (item.is_favorite) ? "remove" : "add";

        confirmAlert({
            title: `Please confirm to ${action}`,
            message: `Are you sure to ${action} this favorite list`,
            buttons: [
                {
                    label: 'No',
                    onClick: () => dispatch(alertSelectors.error("You have not accepted the request."))
                },
                {
                    label: 'Yes',
                    onClick: () =>
                        itemService.favorite(method, params, param)
                            .then(response => {
                                if(response.success) {
                                    if (method === "POST") dispatch(alertSelectors.success("You have successfully selected a favorite."));
                                    if (method === "DELETE") dispatch(alertSelectors.success("You have successfully removed a favorite."));
                                    item.is_favorite = (method === "POST") ? response.model.id : false;
                                    this.setState({ favorite: item });
                                } else {
                                    dispatch(alertSelectors.error("You have not accepted the request."));
                                }
                            })
                            .catch(exception => {
                                gs.showErrors(dispatch, exception, alertSelectors);
                            })
                }
            ]
        });
    }

    onPageUp = (event) => {
        const formField = { ...this.state.formField };
        formField['page'] = formField['page'] + 1;
        this.setState({ formField }, () => this.loadTutor(formField));
    }

    onPageDown = (event) => {
        const formField = { ...this.state.formField };
        formField['page'] = formField['page'] - 1;
        this.setState({ formField }, () => this.loadTutor(formField));
    }

    tutorPriceRange = (item, selectedSubject) => {
        let subjects = item.userCatalogs;

        if (selectedSubject) {
            subjects = subjects.filter(subject => subject.title === selectedSubject);
        }

        const prices = subjects.map(subject => Number(subject.price)).sort();

        if (prices.length === 0) {
            return '';
        }

        const minPrice = prices[0];
        const maxPrice = prices[prices.length - 1];

        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        const minPriceFormatted = formatter.format(minPrice);
        const maxPriceFormatted = formatter.format(maxPrice);

        if (minPrice === maxPrice) {
            return `${minPriceFormatted} per hour`;
        }

        return `${minPriceFormatted} - ${maxPriceFormatted} per hour`;
    }

    render() {
        this.validator.purgeFields();
        const { items, pagination, formField, loading, open } = this.state;
        const { authentication, categories } = this.props;
        const user = authentication && authentication.authentication && authentication.authentication.user;
        let cateArray = categories && categories.data ? categories.data : [];
        //console.log('items', formField);

        return (<Main>
            <LoginDialog open={open} handleClose={() => this.setState({open: false})} link={`/search-tutors`} />
            <section className="listing-page my-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="search-boxs">      
                                <form name="search" onSubmit={this.handleSubmit} noValidate> 
                                    <div className="form-row">
                                        <div className="form-group">
                                            <input type="text" className="form-control" value={formField.name} name="name" onChange={this.handleChange} placeholder="Enter Name"/>
                                        </div>
                                        <div className="form-group">
                                            <select className="form-control custom-select" name="subject" onChange={this.handleChange} value={formField.subject} defaultValue={formField.subject}>
                                                <option value="">Select</option>
                                                {cateArray && cateArray.map(item => <option key={`cat-${item.id}`} value={item.name}>{item.name}</option> )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" className="form-control" value={formField.location} name="location" onChange={this.handleChange} placeholder="Enter Zip Code"/>
                                        </div>                                      
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-primary h-100 ">Search</button> 
                                        </div>
                                    </div>
                                </form>   
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="title">
                                {pagination && pagination.totalCount} Tutor(s) Found
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {loading ? <>
                            {[1,2,3,4].map((item) =>
                                <div className="col-md-3" key={`loading-${item}`}>
                                    <div className="arrival-box">
                                        <div className="image">
                                            <Skeleton variant="circle" width={'100%'} height={200} />
                                        </div>
                                        <div className="caption">
                                            <Skeleton />
                                            <Skeleton />
                                            <Skeleton />
                                            <Skeleton width="80%" />
                                            <Skeleton width="70%" />
                                            <Skeleton width="60%" />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                         : <> 
                            {items && items.map(item => 
                                <div className="col-lg-3 col-md-6 mb-4" key={item.user_id}>
                                    <div className="arrival-box">
                                        <div className="image text-center">
                                            <img className="img-circle" src={(item && item.avatar) ? item.avatar.thumb : '/images/dummy-profile.png'} alt="" />
                                        </div>
                                        <div className="caption text-center">
                                            <h5><Link to={`/tutor/view/${item.user_id}`}>{item.name}</Link></h5>  
                                            <div className="rating text-center d-flex justify-content-center">
                                                <span className="star">
                                                    <Rating name="size-small" size="small" defaultValue={parseFloat(item.avg_rating)} readOnly />
                                                </span >
                                                <span className="rate"> ({item.avg_rating}) {item.count_rating} Ratings</span>
                                            </div>
                                            <h6 className="text-primary text-truncate">
                                                {item.userCatalogs && item.userCatalogs.map(subject => subject.title).join(', ')}
                                            </h6>
                                            <div className="mb-4 text-lg-center font-weight-bold text-info">
                                                {this.tutorPriceRange(item, formField.subject)}
                                            </div>
                                            <p className="address">{item.countryCode && item.countryCode.name}</p>
                                            
                                                                                                
                                                {((user && user.role !== Role.Tutor) || (user === null)) &&                                            
                                                <div className="wishlist justify-content-between d-flex">                                                
                                                    <IconButton className="favorite p-0 mx-2" aria-label="Favorite" onClick={() => this.markAsFavorite(item)}>
                                                        <i className={`fas fa-heart ${item.is_favorite ? 'text-primary' : ''}`}></i>
                                                    </IconButton>
                                                </div>}
                                            
                                           

                                        </div>
                                    </div>
                                </div>
                            )}
                            {(items && items.length === 0) && <div className="col-12 py-3 text-left text-white">Tutor not found</div>}
                        </>}
                        <div className="col-12 text-center">
                            <div className="d-flex justify-content-center" data-test="steven-was-here">
                                {pagination && pagination.pageCount > 1 && <>
                                    <Pagination size="large" color="primary">
                                        <Pagination.Prev disabled={pagination.page === 0} onClick={this.onPageDown} />
                                        <Pagination.Next disabled={pagination.page === pagination.pageCount - 1} onClick={this.onPageUp} />
                                    </Pagination>
                                </>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Main>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const categoriesSelector = createSelector(
    state => state.categories,
    categories => categories
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    categoriesSelector,
    (process, authentication, categories) => ({
        process, authentication, categories
    })
);

export default connect(mapStateToProps)(TutorSearch);
